'use client'

type TFn = (key: string) => string

export default function AirestroAnnouncementBar({
  t,
  className,
}: {
  t: TFn
  lang?: string
  className?: string
}) {
  const items = [
    t('airestroHeader.announce1'),
    t('airestroHeader.announce2'),
    t('airestroHeader.announce3'),
  ].filter(Boolean)

  if (items.length === 0) return null

  const text = items.join('\u2003·\u2003')

  return (
    <div
      className={['ar-announcement-bar', className].filter(Boolean).join(' ')}
      role="region"
      aria-label={t('airestroHeader.announceAria')}
    >
      <p className="sr-only">{text}</p>
      <div className="ar-announcement-marquee" aria-hidden>
        <div className="ar-marquee-viewport">
          <div className="ar-marquee-track">
            <span className="ar-marquee-chunk">{text}</span>
            <span className="ar-marquee-chunk">{text}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
